import { render, staticRenderFns } from "./LoginModalBiz.vue?vue&type=template&id=2f6af7b5&scoped=true&"
import script from "./LoginModalBiz.vue?vue&type=script&lang=js&"
export * from "./LoginModalBiz.vue?vue&type=script&lang=js&"
import style0 from "./LoginModalBiz.vue?vue&type=style&index=0&id=2f6af7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6af7b5",
  null
  
)

export default component.exports